import {sleep} from 'lib/utilities';

export function log<T>(value: T, message: string = null): T {
    if (message) {
        console.log(message + ': ', value);
    } else {
        console.log(message);
    }

    return value;
}

export function cmp(a: number, b: number) {
    if (a < b) {
        return -1;
    } else if (a === b) {
        return 0;
    } else {
        return 1;
    }
}

export function abs_diff(a: number, b: number) {
    return Math.max(a, b) - Math.min(a, b);
}

export function random(min: number, max: number) {
    return Math.random() * (max - min) + min;
}

export function random_int(min: number, max: number) {
    return Math.floor(random(min, max));
}

export function random_biased(min: number, max: number, bias = (max - min) / 2, degree = 1) {
    const value = random(min, max);
    const factor = Math.random() * degree;

    return value * (1 - factor) + bias * factor;
}

export function is_promise<T = any>(value: any): value is Promise<T> {
    if (typeof value === 'object' && value) {
        return typeof value.then === 'function' && typeof value.catch === 'function';
    }
}

export function array_each<T>(array: ArrayLike<T>, iterator: (item: T, index: number) => any) {
    let i = 0, l = array.length;

    while (i < l) {
        iterator(array[i], i);
        ++i;
    }
}

export function array_includes_any<T>(array: T[], items: T[]): boolean {
    for (const item of items) {
        if (array.includes(item)) {
            return true;
        }
    }

    return false;
}

export function kebab_case(string: string): string {
    return string.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase())
}

function generate_unique_id_function() {
    let id = 0;

    return function () {
        return ++id;
    }
}

export const unique_id = generate_unique_id_function();

export function safe_call<T extends (...args: any[]) => any>(message: string, f: T, ...args: Parameters<T>): ReturnType<T> | undefined {
    try {
        return f(...args);
    } catch (error) {
        console.error(message);
        console.error(error);
    }
}

export async function safe_call_async<T extends (...args: any[]) => any>(message: string, f: T, ...args: Parameters<T>): Promise<ReturnType<T> | undefined> {
    try {
        return await f(...args);
    } catch (error) {
        console.error(message);
        console.error(error);
    }
}

export async function async<A extends any[], C extends (...args: A) => any>(callback: C = null, ...args: A) {
    await sleep(0);

    if (callback) {
        callback(...args);
    }
}